import { render, staticRenderFns } from "./SlideWaiting.vue?vue&type=template&id=0c183d3b&scoped=true&"
import script from "./SlideWaiting.vue?vue&type=script&lang=js&"
export * from "./SlideWaiting.vue?vue&type=script&lang=js&"
import style0 from "./SlideWaiting.vue?vue&type=style&index=0&id=0c183d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c183d3b",
  null
  
)

export default component.exports